import React, { Component } from 'react';
import PhotoThumb from '../PhotoThumb';

export default class MoodActivity extends Component {
  render() {
    const { activity } = this.props;
    return (
      <div className="activity__mood">
        <div className="activity__paragraph">{`${activity.data.mood}. ${activity.data.desc}`}</div>
        <PhotoThumb photoUrl={activity.photo_url} />
      </div>
    );
  }
}
